// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"9332349b1a8bf6b17c35","245":"f5165e1b6965e8bfe021","452":"bff4af2fa9f63f36edf9","453":"d5ad5271c46fc3f10d2d"}[chunkId] + ".js";
};